import { createPortal } from "react-dom";
import { X } from "lucide-react";

/**
 * Modal de confirmación reutilizable (reemplazo de window.confirm).
 * Se renderiza en document.body para que el overlay cubra toda la pantalla (sin cortes).
 */
const ConfirmModal = ({
  open,
  onClose,
  title,
  message,
  confirmLabel = "Eliminar",
  cancelLabel = "Cancelar",
  onConfirm,
  danger = true,
}) => {
  const handleConfirm = async () => {
    try {
      if (typeof onConfirm === "function") await onConfirm();
      onClose();
    } catch (e) {
      // El llamador muestra toast; no cerramos el modal si falla
    }
  };

  if (!open) return null;

  const content = (
    <div className="modal-overlay fixed inset-0 min-h-[100dvh] h-[100dvh] bg-slate-900/50 backdrop-blur-sm z-[100] flex items-center justify-center p-3 sm:p-4 py-6">
      <div className="glass-panel p-6 w-full max-w-sm my-auto animate-slide-up">
        <div className="flex items-start justify-between gap-4 mb-4">
          <h3 className="text-lg font-bold text-slate-800">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors text-slate-500"
            aria-label="Cerrar"
          >
            <X size={20} />
          </button>
        </div>
        <p className="text-slate-600 text-sm mb-6">{message}</p>
        <div className="flex gap-3 justify-end">
          <button type="button" onClick={onClose} className="btn-secondary">
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className={danger ? "btn bg-rose-600 hover:bg-rose-700 text-white px-4 py-2 rounded-xl font-medium transition-colors" : "btn-primary"}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default ConfirmModal;
